export default __webpack_public_path__ + "static/media/anatomy-image-8-inverse.26897222.png";